// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"8324":"service-worker","8592":"common"}[chunkId] || chunkId) + ".js";
};